<ion-header
  class="ion-no-border"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'modal-header-tablet'
        : 'modal-header-mobile'
      : 'modal-header-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons *ngIf="platform === platformRef.desktop" slot="end">
      <ion-button
        data-cy="close-ingredient-deletion-modal-button"
        (click)="dismissModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content
  class="simple-action-modal_content"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'modal-content-tablet'
        : 'modal-content-mobile'
      : 'modal-content-desktop'
  "
>
  <div class="content flex-column-gap">
    <div class="alert-icon">
      <ion-icon
        src="../../../../../../assets/icon/search-not-found.svg"
      ></ion-icon>
    </div>
    <div class="delete-modal-text">
      <div
        class="header-text text-large-title text-black"
        data-cy="delete-ingredient-header"
      >
        {{ 'i18n.menuProfitPro.deleteIngredientModal.header' | translate }}
      </div>
      <p class="text-body text-black" data-cy="delete-ingredient-description">
        {{ 'i18n.menuProfitPro.deleteIngredientModal.text' | translate }}
      </p>
    </div>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platform === platformRef.desktop"
>
  <ion-toolbar>
    <ion-buttons class="button-row-gap">
      <ion-button
        data-cy="confirm-ingredient-deletion-button"
        class="confirm-button"
        [ngClass]="
          platform !== platformRef.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="confirmDeletion()"
      >
        {{ 'i18n.common.continue' | translate }}
      </ion-button>
      <ion-button
        data-cy="cancel-ingredient-deletion-button"
        class="cancel-button"
        [ngClass]="
          platform !== platformRef.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="dismissModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
